"use client";

import { Button } from "@repo/ui/components/ui/button";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

export default function ErrorComponent({
  statusCode,
  message,
  backMessage,
  url,
}: {
  statusCode?: number;
  message?: string;
  backMessage?: string;
  url?: string;
}) {
  const router = useRouter();
  const t = useTranslations("Errors");

  function backAndReload() {
    if (url) {
      router.push(url);
    } else {
      router.back();
    }
  }

  return (
    <div className="h-96 w-full flex flex-col items-center justify-center gap-5">
      <div>
        <h3 className="whitespace-pre-line text-center leading-[1]">
          {statusCode
            ? `An error ${statusCode} occurred on server`
            : t(message || "something-went-wrong")}
        </h3>
      </div>
      <div className="flex gap-4 mt-10">
        <Button variant="outline" onClick={backAndReload}>
          {t(backMessage || "back")}
        </Button>
      </div>
    </div>
  );
}

/*error.getInitialProps = ({ res, err }: { res?: any; err?: any }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};*/
